/**
 * Convenience wrapper around the <image-slot> custom element so React's
 * JSX-prop-warning stays quiet and so you get auto-completion. The element
 * itself is defined in /public/image-slot.js (loaded from index.html).
 */
export default function ImageSlot({ id, shape = 'rounded', radius, placeholder, src, fit, position, mask, style, className }) {
  // The underlying <image-slot> custom element has a 240×160 default size
  // baked into its :host CSS. If the caller absolutely-positions the slot
  // (style.position === 'absolute') without setting explicit width/height,
  // the host's default width wins over `right: 0` from `inset: 0`, leaving
  // the slot stuck at 240×160 in the top-left of its parent. Fill instead.
  let mergedStyle = style;
  if (style && style.position === 'absolute' && style.width == null && style.height == null) {
    mergedStyle = { width: '100%', height: '100%', ...style };
  }
  return (
    <image-slot
      id={id}
      shape={shape}
      radius={radius}
      placeholder={placeholder}
      src={src}
      fit={fit}
      position={position}
      mask={mask}
      style={mergedStyle}
      class={className}
    />
  );
}
